// all elements with background images that should be lazy loaded
const lazyImages = document.querySelectorAll(".bg-img.bg-lazy")

// options for the observer
const backgroundOptions = {
  threshold: 0,
  rootMargin: "0px 0px 50px 0px",
}

// the observer
const imageObserver = new IntersectionObserver((entries, imageObserver) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      showImageBackground(entry.target)
      imageObserver.unobserve(entry.target)
    }
  })
}, backgroundOptions)

// observe each image
lazyImages.forEach((image) => {
  imageObserver.observe(image)
})

// show background image
function showImageBackground(node) {
  node.classList.remove("bg-lazy")
}
